import React from 'react';

import style from './VaccinationTable.module.scss';
import classnames from 'classnames';

import type { PatientVaccinationData } from 'chaika-frontend-types/frontend-cms';

import { VaccinationHeader } from './components/VaccinationHeader';
import { VaccinationRow } from './components/VaccinationRow';
import { useVaccinationData } from './hooks/useVaccinationData';
import { VaccinationPageAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';
import { store } from '@store';

export const NO_DISEASE_GROUP_NAME = () => translate('otherVaccinations');

export interface VacciantionData extends PatientVaccinationData {
    clinic?: string;
    documents: VaccinationDocument[];
    onVaccinationClick(event: React.MouseEvent<HTMLElement>): void;
}

export interface VaccinationGroup {
    groupName: string;
    vaccinations: VacciantionData[];
}

export interface VaccinationDocument {
    path: string;
    name: string;
    onShowDocument(): Promise<void>;
}

export interface Props {
    vaccinations: VacciantionData[];
}

export function VaccinationTable({ vaccinations }: Props): React.ReactElement<any> {
    const {
        ehr: { rawBirthDate: ehrBirthDate },
    } = store;
    const { vaccinationGroups } = useVaccinationData({ vaccinations });

    return (
        <div
            className={style.root}
            data-test={VaccinationPageAttributes.VaccinationTable}
            data-testid={VaccinationPageAttributes.VaccinationTable}
        >
            <VaccinationHeader />
            {vaccinationGroups.map(({ groupName, vaccinations }) => (
                <React.Fragment key={groupName}>
                    <div
                        className={classnames([
                            style.groupName,
                            groupName === NO_DISEASE_GROUP_NAME() && style.groupName_danger,
                        ])}
                    >
                        {groupName}
                    </div>
                    {vaccinations.map(vaccination => VaccinationRow({ vaccination, ehrBirthDate }))}
                </React.Fragment>
            ))}
        </div>
    );
}
